import {get} from './genericService';

export function getTest() {
  return get('events');
}